/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IGenericJSONMessage,
} from '../types/response.types'

export default new class CustomFiltersAPI extends RequestHandler {
  /****** DELETE methods *****/
  public async delete_Delete(
    custom_filter_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/custom-filters/${custom_filter_id}`,
    })
  }
}()
